import { css } from "lit";

export const holloLanguageMenuStyles = css`
  .hollo-lang-menu {
    position: absolute;
    top: 46px;
    right: 0;
    width: 200px;
    background: #fff;
    border-radius: 14px;
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.15);
    border: 1px solid #e5e7eb;
    padding: 10px 12px 8px;
    z-index: 10;
  }
  .hollo-lang-menu.align-left {
    right: auto;
    left: 20px;
    top: 50px;
  }
  .hollo-lang-title {
    font-weight: 700;
    font-size: 14px;
    color: #111827;
    padding: 4px 6px 10px;
  }
  .hollo-lang-item {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 10px;
    background: #fff;
    border: none;
    padding: 10px 8px;
    cursor: pointer;
    border-radius: 10px;
  }
  .hollo-lang-item:hover {
    background: #f9fafb;
  }
  .hollo-li-divider {
    height: 1px;
    background: #f1f5f9;
    margin: 2px 0;
  }
  .hollo-li-left {
    display: flex;
    align-items: center;
    gap: 10px;
  }
  .hollo-li-flag {
    width: 32px;
    height: 32px;
    display: grid;
    place-items: center;
    border-radius: 50%;
    overflow: hidden;
  }
  .hollo-li-flag img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
  }
  .hollo-li-label {
    font-size: 14px;
    color: #111827;
  }
  .hollo-li-radio {
    width: 18px;
    height: 18px;
    border-radius: 999px;
    border: 2px solid #d1d5db;
    display: grid;
    place-items: center;
  }
  .hollo-li-radio .hollo-dot {
    width: 8px;
    height: 8px;
    border-radius: 999px;
    background: transparent;
  }
  .hollo-lang-item.hollo-selected .hollo-li-radio {
    border-color: #ef476f;
  }
  .hollo-lang-item.hollo-selected .hollo-li-radio .hollo-dot {
    background: #ef476f;
  }

  .hollo-lang-list {
    max-height: 200px;
    overflow-y: auto;
  }

  .hollo-lang-list {
    /* Custom scrollbar styles */
    --sb-track-color: #ffffff;
    --sb-thumb-color: #D1D5DB;
    --sb-size: 3px;
  }

  .hollo-lang-list::-webkit-scrollbar {
    width: var(--sb-size);
  }

  .hollo-lang-list::-webkit-scrollbar-track {
    background: var(--sb-track-color);
    border-radius: 3px;
  }

  .hollo-lang-list::-webkit-scrollbar-thumb {
    background: var(--sb-thumb-color);
    border-radius: 3px;
  }

  @supports not selector(::-webkit-scrollbar) {
    .hollo-messages {
      scrollbar-color: var(--sb-thumb-color) var(--sb-track-color);
    }
  }

`;
